// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Map_wrapper__2S0-X","mapWrapper":"Map_mapWrapper__1x97f","map":"Map_map__XLvjM","selectedCountry":"Map_selectedCountry__d-_kJ","content":"Map_content__qRcpJ"};